module.exports = require('./helpers/bundle-url').getBundleURL('9iXDo') + "clippy_15.43ecfa9e.mp3" + "?" + Date.now();